module.exports = __webpack_public_path__ + "static/img/20211.30158e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20211.jpg
// module id = MbHU
// module chunks = 1